import { trpc } from "../trpc";

export function useDeleteFolder() {
  const utils = trpc.useUtils();

  const mutation = trpc.folder.delete.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: () => {
      utils.folder.folderTree.cancel(); // cancel outgoing refetches to folderTree

      // Unable to optimistically update the cache since removing from the folderTree removes the folderRow from the DOM, success or error toasts will not be displayed
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: () => {
      // Invalidate folderTree key to refetch data
      utils.folder.folderTree.invalidate();
    },
  });

  return {
    delete: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
